/*
 * Items should not be deleted, they should be created by an admin and it's content shoud be edited only
 * Define pages
 * - Início
 * - Serviços
 * - Empresa
 *
 * Define Home Items
 *
*/
const env = process.env.NODE_ENV

const APP = {
  dev: 'http://localhost:80',
  // Same-origin: nginx on the production host serves the built SPA and
  // reverse-proxies /api and /oauth to the backend container, so a relative
  // path works regardless of domain/IP/http-vs-https, no hardcoded host.
  prod: ''
}

const devIndex = {
  // home: 1,
  // services: 2,
  // about: 0,
  // network: 3
  home: 3,
  services: 2,
  about: 0,
  network: 1
}

const prodIndex = {
  home: 3,
  services: 2,
  about: 0,
  network: 1
}

export const index = env === 'production' ? prodIndex : devIndex

export const api = options => {
  let secure = options.secure === undefined ? true : options.secure
  let clerance = options.clerance === undefined ? '' : (options.clerance === 'admin' ? '' : options.clerance + '/')
  if (secure) {
    if (env === 'production') return `${APP.prod}/api/v1/${options.service ? options.service + '/' : ''}${options.target}`
    return `${APP.dev}/api/v1/${clerance}${options.service ? options.service + '/' : ''}${options.target}`
  } else {
    if (env === 'production') return `${APP.prod}/${options.service ? options.service + '/' : ''}${options.target}`
    return `${APP.dev}/${options.service ? options.service + '/' : ''}${options.target}`
  }
}
export const header = (authTokens) => {
  const headers = {
    'Accept': 'application/json',
    'Authorization': 'Bearer ' + authTokens.access_token
  }
  return headers
}
